export const DEFAULT_QUERY_CLIENT_CONFIG = {
	defaultOptions: {
		queries: {
			staleTime: 1000 * 60 * 5, // 5 minutes
			gcTime: 1000 * 60 * 30, // 30 minutes (formerly cacheTime)
			retry: 3,
			refetchOnWindowFocus: false,
		},
	},
};

export const USER_LISTS_QUERY_KEY = ['userLists'] as const;
